//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required, numeric, decimal, minLength, maxLength, minValue, maxValue, helpers } from "vuelidate/lib/validators";
import ValidateResult from "@/library/ValidateResult";
import config from "@/config";
import errorTags from "@/ErrorTags";

const containDate = helpers.regex("containAlphaNum", /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/);
const containDecimal = helpers.regex("containDecimal", /^\d*\.?\d+$/);

export default {
  components: {
		ValidateResult
	},
	props: {
		paraDialogDelete: {
      type: Boolean
    },
		paraMatchDate: "",
		paraRedNumber: "",
		paraPool: ""
	},
  data: function() {
    return {
      blnDense: false,
      blnLoading: false,

			blnShowMessage: false,
      strBannerClass: "",
      strBannerMessage: "",

      jsonResponse: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    getMatchDate: function() {
			return this.paraMatchDate;
    },
    getRedNumber: function() {
			return this.paraRedNumber;
    },
    getPool: function() {
			return this.paraPool;
    }
  },
  methods: {
    fcReset: function() {
      this.blnShowMessage = false,
      this.strBannerClass = "",
      this.strBannerMessage = ""
    },
    fcCancel () {
      this.$emit("cancel");
			this.fcReset();
		},
    fcDelete () {
      let apiURL = config.matchNumberDelete_Url();

      var jsonRequest = {
        session_token: this.$store.getters.sessionToken,
        user_id: this.$store.getters.username,
        match_date: this.getMatchDate,
        red_num: this.getRedNumber,
      };

      // console.log(jsonRequest);

      this.blnLoading = true;
      this.jsonResponse.success = true;

      this.$http.post(apiURL, jsonRequest).then(
        function(apiResponse) {
          // Json Response Success
          // console.log(apiResponse);

          this.blnLoading = false;

          try {
            if (apiResponse) {
              if (typeof apiResponse.data.status == "string") {
                this.jsonResponse.success = apiResponse.data.status == "1";
              } else {
                this.jsonResponse.success = apiResponse.data.status == 1;
              }

              this.jsonResponse.status = apiResponse.data.statusdesc;

              if (this.jsonResponse.success == true) {
                this.$emit("success", this.getMatchDate, this.getRedNumber, this.getPool);
                this.fcReset();
              } else {
                this.$emit("fail", "delete_match_number", this.jsonResponse.status);

                if (apiResponse.data.status == 500){
                  this.jsonResponse.status = "SystemError";
                } else if (apiResponse.data.status == 501) {
                  this.jsonResponse.status = "RedNumberExists";
                }

                this.blnShowMessage = true;
                this.strBannerClass = "cssBannerError";
                this.strBannerMessage = this.jsonResponse.status;

                if (this.jsonResponse.status == "invalidToken"){
                	this.$helpers.handleFeedback(this.jsonResponse.status);
                }
              }
            }
          } catch (error) {
            this.jsonResponse.success = false;
            this.jsonResponse.status = errorTags.request.failed;
          }
        },
        function(apiResponse) {
          // Json Response Error
          this.blnLoading = false;
          this.jsonResponse.success = false;
          this.jsonResponse.status = errorTags.request.failed;
        }
      );
    }
	}
};
